export default __webpack_public_path__ + "static/media/omid.fbc91685.png";